import { useInjection } from 'inversify-react';
import { useCallback } from 'react';

import { TYPES } from '../../inversify.types';
import { IViewerStoreInjector } from '../../store';
import { Theme } from '../../store/viewer/viewer.types';

export const useThemeModeHandler = () => {
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const setTheme = useViewerStore((state) => state.setTheme);
  const themeMode = useViewerStore((state) => state.theme);

  const toggleThemeMode = useCallback(() => {
    setTheme(themeMode === Theme.Light ? Theme.Dark : Theme.Light);
  }, [setTheme, themeMode]);

  return {
    toggleThemeMode,
    themeMode,
  };
};
